import type { AcqRateKind } from "~domain/devices/models/acq-rate-model.ts";

const acqRateKind: Record<AcqRateKind, string> = {
  DAY: "24 heures",
  WEEK: "7 jours",
  MONTH: "30 jours",
};

export const MODULATOR_ACQ_RATE_CARD_FRENCH_LOCALE = {
  title: "Taux d'acquisition",
  acqRateKind: acqRateKind,
};
